import { normalize } from "../common";
import { CONTAINER_NAME } from "../_utils/constant";
var openDocument = normalize.openDocument(function (options) {
  var filePath = options.filePath,
      fileType = options.fileType,
      _success = options.success,
      _fail = options.fail,
      _complete = options.complete;
  tt.openDocument({
    filePath: filePath,
    fileType: fileType,
    success: function success() {
      _success && _success();
    },
    fail: function fail(res) {
      _fail && _fail(res);
    },
    complete: function complete(res) {
      _complete && _complete(res);
    }
  });
}, CONTAINER_NAME.BYTE);
export default openDocument;